import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ResultadoService } from './resultado.service';
import { TDatosResponsableCaAcViewModel, TSolicitudResultadoAtestFitoViewModel } from './resultado.types';
import { Observable } from 'rxjs';
import { Tc, TcPerfilUsuarioEnum } from '../../../core/_infrastructure/types/common';
import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { SolicitudAtestFitoService } from '../datosbasicos/datosbasicosAtestFito.service';
import { EnumIdsTcResultadoSolicitudAtestFito } from '../types/enum';

@Component({
    selector: 'app-resultado',
    templateUrl: './resultado.component.html',
})
/** resultado component*/
export class ResultadoComponent extends ComponentBase implements OnInit {
    /** resultado ctor */

    editMode = false;
    //editTitle: string = "Nueva";

    habilitarGuardar = true;
    habilitarEdicion = true;

    datosResponsableCaAc: TDatosResponsableCaAcViewModel;
    solicitudAtestFitoAgenteControl: TSolicitudResultadoAtestFitoViewModel;
    listResultadoSolicitud: Tc[];
    codigoTipoSolicitud: string;
    tituloTipoSolicitudAtestFito: string;
    tituloEstadoSolicitudAtestFito: string;

    visibilitySpinnerGuardar = false;
    IdEstadoSolicitudAtestFito: number;
    refAtestFito: string;

    esComunidad = false;
    esAgenteControl = false;
    IdSolicitudAtest: number;

    IdTipoSolicitudAtestFito: number;

    campoObligatorio = true;

    fechaFinalizacion: string | null = null;

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,

        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private solicitudAtestFitoService: SolicitudAtestFitoService,
        private navMenuService: NavMenuService,
        private resultadoService: ResultadoService,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.datosResponsableCaAc = new TDatosResponsableCaAcViewModel();
    }

    ngOnInit() {
        this.globalService.getResultadoSolicitudAtestFito().subscribe(res => {
            this.listResultadoSolicitud = res;
        });

        let id = +this.activatedRoute.snapshot.params['id'];

        this.IdSolicitudAtest = id;
        this.esComunidad = this.isCA;
        this.esAgenteControl = this.loggedInUser!.hasProfile(TcPerfilUsuarioEnum.AgenteControl);

        this.guardRefreshPage(id);

        this.createForm();

        //Siempre tendrá un id.
        if (id) {
            this.loading = true;

            //recuperar la solicitud
            this.resultadoService.getResultadoSolicitudAtestFito(id).subscribe(result => {
                //HAY RESULTADO
                if (result) {
                    this.editMode = true;

                    this.datosResponsableCaAc = result;

                    this.IdTipoSolicitudAtestFito = this.datosResponsableCaAc.IdTipoSolicitud;
                    this.IdEstadoSolicitudAtestFito = this.datosResponsableCaAc.IdEstado;
                    this.tituloTipoSolicitudAtestFito = this.datosResponsableCaAc.IdTipoSolicitudDescripcion;
                    this.tituloEstadoSolicitudAtestFito = this.datosResponsableCaAc.IdEstadoDescripcion;
                    this.codigoTipoSolicitud = this.datosResponsableCaAc.CodigoTipoSolicitud;

                    this.refAtestFito = this.datosResponsableCaAc.RefAtestFito;

                    this.fechaFinalizacion = this.datepipe.transform(this.datosResponsableCaAc.FechaFinalizacion, 'dd/MM/yyyy HH:mm:ss');

                    if (this.codigoTipoSolicitud == 'CA') {
                        this.addValidator('NombreTecResponsable', Validators.required);
                    } else if (this.codigoTipoSolicitud == 'AC') {
                        this.removeValidators('NombreTecResponsable');
                    }

                    this.updateForm();

                    this.loading = false;

                    this.habilitarGuardar = this.loggedInUser!.getAction(
                        EnumCodigosTwTcAcciones.MENU_RESULTADO_ATESTACION,
                        this.datosResponsableCaAc.IdEstado,
                        this.datosResponsableCaAc.IdTipoSolicitud,
                    ).Editable;
                    this.habilitarEdicion = this.loggedInUser!.getAction(
                        EnumCodigosTwTcAcciones.MENU_RESULTADO_ATESTACION,
                        this.datosResponsableCaAc.IdEstado,
                        this.datosResponsableCaAc.IdTipoSolicitud,
                    ).Editable;

                    if (!this.habilitarEdicion) {
                        //metodo para deshabilitar los controles
                        this.DisableControlsConsulta();
                    }
                }
                //NO HAY RESULTADO
                else {
                    this.editMode = false;

                    this.resultadoService.getSolicitudAtestFitoAgenteControl(id).subscribe(result => {
                        this.solicitudAtestFitoAgenteControl = result;

                        this.IdTipoSolicitudAtestFito = this.solicitudAtestFitoAgenteControl.IdTipoSolicitud;
                        this.IdEstadoSolicitudAtestFito = this.solicitudAtestFitoAgenteControl.IdEstado;
                        this.tituloTipoSolicitudAtestFito = this.solicitudAtestFitoAgenteControl.IdTipoSolicitudDescripcion;
                        this.tituloEstadoSolicitudAtestFito = this.solicitudAtestFitoAgenteControl.IdEstadoDescripcion;
                        this.codigoTipoSolicitud = this.solicitudAtestFitoAgenteControl.CodigoTipoSolicitud;

                        this.refAtestFito = this.solicitudAtestFitoAgenteControl.RefAtestFito;

                        this.habilitarGuardar = this.loggedInUser!.getAction(
                            EnumCodigosTwTcAcciones.MENU_RESULTADO_ATESTACION,
                            this.solicitudAtestFitoAgenteControl.IdEstado,
                            this.solicitudAtestFitoAgenteControl.IdTipoSolicitud,
                        ).Editable;
                        this.habilitarEdicion = this.loggedInUser!.getAction(
                            EnumCodigosTwTcAcciones.MENU_RESULTADO_ATESTACION,
                            this.solicitudAtestFitoAgenteControl.IdEstado,
                            this.solicitudAtestFitoAgenteControl.IdTipoSolicitud,
                        ).Editable;

                        this.form.setValue({
                            NombreAgenteControl: this.solicitudAtestFitoAgenteControl.NombreAgenteControl,
                            IdUsuarioAc: this.solicitudAtestFitoAgenteControl.IdUsuarioAc,
                            FechaInspeccion: new Date(this.solicitudAtestFitoAgenteControl.FechaInspeccion),

                            NombreTecResponsable: '',
                            FechaValidezInicio: null,
                            FechaValidezFin: null,
                            IdResultadoSolicitudAtestFito: null,
                            Observaciones: '',
                        });

                        if (this.codigoTipoSolicitud == 'CA') {
                            this.addValidator('NombreTecResponsable', Validators.required);
                            if (this.isCA) {
                                this.form.patchValue({
                                    NombreTecResponsable: this.loggedInUser!.Nombre + ' ' + this.loggedInUser!.Apellidos,
                                });
                            }
                        } else if (this.codigoTipoSolicitud == 'AC') {
                            this.removeValidators('NombreTecResponsable');
                        }

                        if (!this.habilitarEdicion) {
                            //metodo para deshabilitar los controles
                            this.DisableControlsConsulta();
                        }
                    });
                }
            });
        }
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudAtestacion.Id) || this.navMenuService.currentSolicitudAtestacion.Id !== id) {
            this.solicitudAtestFitoService.getSolicitudAtestFito(id).subscribe(result => {
                this.navMenuService.currentSolicitudAtestacion = result;
            });
        }
    }

    private DisableControlsConsulta() {
        this.form.controls['NombreTecResponsable'].disable();
        this.form.controls['FechaValidezInicio'].disable();
        this.form.controls['FechaValidezFin'].disable();
        this.form.controls['IdResultadoSolicitudAtestFito'].disable();
        this.form.controls['Observaciones'].disable();
        this.form.controls['FechaInspeccion'].disable();
    }

    createForm() {
        this.form = this.fb.group({
            NombreTecResponsable: '',
            NombreAgenteControl: '',
            FechaValidezInicio: [null, Validators.required],
            FechaValidezFin: [null, Validators.required],
            IdResultadoSolicitudAtestFito: [null, Validators.required],
            Observaciones: '',
            IdUsuarioAc: null,
            FechaInspeccion: [null, Validators.required],
        });
    }

    updateForm() {
        this.form.setValue({
            NombreTecResponsable: this.datosResponsableCaAc.NombreTecResponsable,
            NombreAgenteControl: this.datosResponsableCaAc.NombreAgenteControl,
            FechaValidezInicio: this.datosResponsableCaAc.FechaValidezInicio != null ? new Date(this.datosResponsableCaAc.FechaValidezInicio) : null,
            FechaValidezFin: this.datosResponsableCaAc.FechaValidezFin != null ? new Date(this.datosResponsableCaAc.FechaValidezFin) : null,
            IdResultadoSolicitudAtestFito: this.datosResponsableCaAc.IdResultadoSolicitudAtestFito,
            Observaciones: this.datosResponsableCaAc.Observaciones,
            IdUsuarioAc: this.datosResponsableCaAc.IdUsuarioAc,
            FechaInspeccion: new Date(this.datosResponsableCaAc.FechaInspeccion),
        });
        //se llama al evento para actualizar los campos required
        this.onSelectResultado();
    }

    onComunicarCA() {
        this.confirmationService.confirm({
            message: '¿Está seguro de notificar a la C.A.?',
            accept: () => {
                //VALIDAR que la Fecha prevista Inspeccion sea superior a 2 días respecto al momento de comunicarlo (momento actual)
                this.resultadoService.sendMailComunicarCa(this.IdSolicitudAtest).subscribe(result => {
                    let mailEnviado = result;
                    if (mailEnviado) {
                        this.addSuccessMessage('Correo enviado correctamente');
                    }
                });
            },
        });
    }

    onSelectResultado() {
        if (this.form.value.IdResultadoSolicitudAtestFito == EnumIdsTcResultadoSolicitudAtestFito.ID_RECHAZADA) {
            this.removeValidators('FechaValidezInicio');
            this.removeValidators('FechaValidezFin');
            this.campoObligatorio = false;
        } else {
            this.addValidator('FechaValidezInicio', Validators.required);
            this.addValidator('FechaValidezFin', Validators.required);
            this.campoObligatorio = true;
        }
    }

    onBack() {
        this.router.navigate(['/exportacion/atestaciones']);
    }

    saveSolicitud() {
        this.confirmationService.confirm({
            message: '¿Está seguro de guardar el resultado de la solicitud?.',
            accept: () => {
                this.onSubmit();
            },
        });
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos de la inspección');
            return;
        }
        if (
            this.form.value.FechaValidezInicio != null &&
            this.form.value.FechaValidezFin != null &&
            this.form.value.FechaValidezInicio > this.form.value.FechaValidezFin
        ) {
            this.addErrorMessage('La Fecha Validez Inicio no puede ser posterior a la Fecha Validez Fin');
            return;
        }
        if (this.form.value.FechaValidezFin != null && new Date() > this.form.value.FechaValidezFin) {
            this.addErrorMessage('La Fecha Validez Fin no puede ser anterior a la fecha actual');
            return;
        }

        this.visibilitySpinnerGuardar = true;

        let datosResponsableCaAc = new TDatosResponsableCaAcViewModel();

        if (this.codigoTipoSolicitud == 'CA') {
            datosResponsableCaAc.NombreTecResponsable = this.form.value.NombreTecResponsable;

            //si es tipo CA le paso el usuario logado en el campo IdUsuarioAc para guardar el IdUsuarioCa de la solicitudAtestFito
            datosResponsableCaAc.IdUsuarioAc = this.loggedInUser!.Id;
        } else if (this.codigoTipoSolicitud == 'AC') {
            datosResponsableCaAc.IdUsuarioAc = this.form.value.IdUsuarioAc;
            datosResponsableCaAc.FechaInspeccion = this.form.value.FechaInspeccion;
        }
        //datosResponsableCaAc.NombreAgenteControl = this.form.value.NombreAgenteControl;
        datosResponsableCaAc.FechaValidezInicio = this.form.value.FechaValidezInicio;
        datosResponsableCaAc.FechaValidezFin = this.form.value.FechaValidezFin;
        datosResponsableCaAc.IdResultadoSolicitudAtestFito = this.form.value.IdResultadoSolicitudAtestFito;
        datosResponsableCaAc.Observaciones = this.form.value.Observaciones;

        datosResponsableCaAc.IdSolicitudAtestFito = this.IdSolicitudAtest;

        if (this.editMode) {
            this.resultadoService.editResultadoAtestFito(datosResponsableCaAc).subscribe({
                next: res => {
                    this.addSuccessMessage('Resultado guardado correctamente');
                    //this.onBack();
                    this.visibilitySpinnerGuardar = false;

                    this.ngOnInit();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinnerGuardar = false;
                    if (error.error.error.includes('enviar correo')) {
                        this.ngOnInit();
                    }
                },
            });
        } else {
            this.resultadoService.createResultadoAtestFito(datosResponsableCaAc).subscribe({
                next: res => {
                    this.addSuccessMessage('Resultado guardado correctamente');
                    //this.onBack();
                    this.visibilitySpinnerGuardar = false;

                    this.ngOnInit();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinnerGuardar = false;
                    if (error.error.error.includes('enviar correo')) {
                        this.ngOnInit();
                    }
                },
            });
        }
    }
}
